import React from "react";
import { cn } from "@/lib/utils";

/** Skarpenord mark: the brand star on a navy tile; white tile with navy star on dark surfaces; `bare` = the star alone in navy. */
export const LosMark = ({ className, testId, tone = "ink" }) => {
  const tile = tone === "white" ? "white" : "hsl(var(--brand))";
  const star = tone === "white" || tone === "bare" ? "hsl(var(--brand))" : "white";
  return (
    <svg viewBox="0 0 32 32" className={cn("shrink-0", className)} data-testid={testId} aria-hidden="true">
      {tone !== "bare" ? <rect width="32" height="32" rx="8" fill={tile} /> : null}
      <path d="M16 6.2l2.72 6.17 6.68.64-5.03 4.47 1.49 6.6L16 20.6l-5.86 3.48 1.49-6.6-5.03-4.47 6.68-.64z" fill={star} />
    </svg>
  );
};

/** Real Skarpenord wordmark (star over the final d). `variant` white for dark surfaces, dark (navy) for light. */
export const LosLogo = ({ variant = "dark", className, testId, withMark = false }) => (
  <span className={cn("inline-flex items-center gap-2.5", className)} data-testid={testId}>
    {withMark ? <LosMark className="h-[1.3em] w-[1.3em]" tone={variant === "white" ? "white" : "ink"} /> : null}
    <img
      src={variant === "white" ? "/brand/skarpenord-logo-white.png" : "/brand/skarpenord-logo-navy.png"}
      alt="Skarpenord"
      className="h-[1em] w-auto select-none"
      draggable={false}
    />
  </span>
);

export const SkarpenordMark = LosMark;
export const SkarpenordLogo = LosLogo;
